module.exports = __webpack_public_path__ + "static/img/00080B_1_2_C_20210606_LC.f2e07aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00080B_1_2_C_20210606_LC.png
// module id = Io4E
// module chunks = 0